export function onlyNumber(e: KeyboardEvent, allowFloat: boolean = false) {
	const a = [];
	const k = e.which;

	// Ctrl+A,Ctrl+C,Ctrl+V, Command+A
	if ((k === 65 || k === 86 || k === 67) && (e.ctrlKey === true || e.metaKey === true)) {
		a.push(k);
	}

	// liczby 1-9
	for (let i = 48; i < 58; i++) a.push(i);

	// klawiatura numeryczna
	for (let i = 96; i < 106; i++) a.push(i);

	// Backspace
	if (k === 8) {
		a.push(k); // Backspace
	}

	// Przecinek i kropka
	if (allowFloat && [188, 190, 110].includes(k)) {
		a.push(k);
	}

	if (!(a.indexOf(k) >= 0)) e.preventDefault();
}

export function preventInput(e: KeyboardEvent, isNumeric: string, allowFloat: boolean = false) {
	let proceed = false;
	const key = ['ArrowUp', 'ArrowDown', 'KeyE', ...(isNumeric === 'float' ? ['Period', 'Comma', 'NumpadDecimal'] : [])].indexOf(e.code) > -1;

	if (e.code === 'Enter') {
		proceed = true;
	}

	if (isNumeric && key) {
		e.preventDefault();

		// If allowFloat is true, replaces comma with period
		if (allowFloat && ['Comma', 'NumpadDecimal'].includes(e.code)) {
			const target = e.target as HTMLInputElement;
			target.value += '.';
		}
	}

	return proceed;
}
